import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button, Card, Group, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";

import { PaginatedList } from "@components/shared";
import { formatDate, formatTime } from "@util/dates";
import alertNavigationPath from "./alertNavigationPath";

function alertStamp(value) {
  if (!value) return "";
  return `${formatDate(value)} ${formatTime(value)}`;
}

export default function AlertList({ refresh }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [listRefresh, setListRefresh] = useState(false);

  function openAlert(alert) {
    axios
      .post(`/alerts/${alert.id}/mark-viewed/`, {})
      .catch(() => {})
      .finally(() => {
        const path = alertNavigationPath(alert);
        if (path) {
          navigate(path);
        } else {
          setListRefresh((value) => !value);
        }
      });
  }

  function dismissAlert(alert) {
    axios
      .post("/dismiss-alerts/", { alert_ids: [alert.id] })
      .then(() => {
        toast.success(t("dismissed"));
        setListRefresh((value) => !value);
      })
      .catch((err) => toast.error(err));
  }

  return (
    <PaginatedList
      requestInfo={{
        url: "/retrieve-alerts/",
        data: { refresh, listRefresh },
      }}
      responseMapping={(rows) => rows}
      displayFormatter={(item) => {
        const alert = item.original;
        return (
          <Card key={alert.id} withBorder mb="sm">
            <Group justify="space-between" align="flex-start">
              <Stack gap={4} style={{ flexGrow: 1 }}>
                <Text fw={alert.viewed ? 400 : 600}>{alert.title}</Text>
                <Text size="xs" c="dimmed">
                  {alert.context_formatted} · {alertStamp(alert.created_at)}
                </Text>
              </Stack>
              <Group gap="xs">
                <Button size="xs" variant="light" onClick={() => openAlert(alert)}>
                  {t("open")}
                </Button>
                <Button
                  size="xs"
                  variant="subtle"
                  color="gray"
                  onClick={() => dismissAlert(alert)}
                >
                  {t("dismiss")}
                </Button>
              </Group>
            </Group>
          </Card>
        );
      }}
    />
  );
}
